import { SVGInterface } from "../../interface";

const ArrowSolidLeft = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M14.5 7L9.5 12L14.5 17V7Z" fill={color || "#0E171F"} />
  </svg>
);

export default ArrowSolidLeft;
